var e = {
	host: /* @__PURE__ */ JSON.parse("{\"list\":{\"title\":\"Properties\",\"subtitle\":\"Manage your properties, units, and listings.\",\"searchPlaceholder\":\"Search properties...\",\"moreFilters\":\"More Filters\",\"emptyMessage\":\"No properties yet. Add your first property to get started.\",\"addProperty\":\"Add Property\"},\"drafts\":{\"title\":\"Drafts ({{count}})\",\"newProperty\":\"New Property\",\"noLocation\":\"No location set\",\"lastEdited\":\"{{location}} · Last edited {{date}}\",\"deleteDraft\":\"Delete draft\",\"deleteConfirm\":\"Are you sure you want to delete this draft?\"},\"filters\":{\"allPropertyTypes\":\"All property types\",\"allRentalTypes\":\"All rental types\",\"allCities\":\"All cities\",\"propertyType\":\"Property type\",\"rentalType\":\"Rental type\",\"city\":\"City\",\"bedrooms\":\"Bedrooms\",\"bathrooms\":\"Bathrooms\"},\"table\":{\"name\":\"Name\",\"type\":\"Type\",\"location\":\"Location\",\"units\":\"Units\",\"listings\":\"Listings\",\"price\":\"Price\",\"unit_one\":\"{{count}} unit\",\"unit_other\":\"{{count}} units\",\"listing_one\":\"{{count}} listing\",\"listing_other\":\"{{count}} listings\",\"status\":\"Status\",\"emptyMessage\":\"No properties match your search.\"},\"status\":{\"allLive\":\"Live\",\"noListings\":\"No listings yet\",\"suspended_one\":\"Suspended\",\"suspended_other\":\"{{count}} suspended\",\"unpublished_one\":\"Unpublished\",\"unpublished_other\":\"{{count}} unpublished\",\"needsApproval_one\":\"Needs approval\",\"needsApproval_other\":\"{{count}} need approval\"},\"groups\":{\"title\":\"Property Groups\",\"subtitle\":\"Manage property groups and user assignments.\",\"createGroup\":\"Create Group\",\"searchPlaceholder\":\"Search groups...\",\"assignUsers\":\"Assign users\",\"emptyMessage\":\"No property groups found.\",\"columnName\":\"Name\",\"columnDescription\":\"Description\",\"columnProperties\":\"Properties\",\"assignToUser\":\"Assign to User\",\"deleteGroup\":\"Delete Group\",\"noDescription\":\"No description provided.\",\"untitledProperty\":\"Untitled property\",\"noPropertiesFound\":\"No properties found.\",\"noSearchResults\":\"No groups match your search.\",\"notFound\":\"Property group not found\",\"backToGroups\":\"Back to Groups\",\"propertyCount_one\":\"{{count}} property\",\"propertyCount_other\":\"{{count}} properties\",\"memberCount_one\":\"{{count}} member\",\"memberCount_other\":\"{{count}} members\",\"created\":\"Property group created\",\"createError\":\"Failed to create the property group\",\"deleted\":\"Property group deleted\",\"deleteError\":\"Failed to delete the property group\",\"delete\":{\"title\":\"Delete property group?\",\"message_one\":\"Deleting “{{name}}” removes the access it grants — {{count}} member will lose every property in it. This cannot be undone.\",\"message_other\":\"Deleting “{{name}}” removes the access it grants — {{count}} members will lose every property in it. This cannot be undone.\",\"action\":\"Delete {{name}}\"},\"assign\":{\"description\":\"Search and select members to add to {{name}}. They get every property in the group.\",\"searchPlaceholder\":\"Search by name or email...\",\"allAssigned\":\"All workspace members are already in this group.\",\"success_one\":\"{{count}} member added to the group\",\"success_other\":\"{{count}} members added to the group\",\"error\":\"Failed to add members to the group\"},\"unassign\":{\"title\":\"Remove from group?\",\"message\":\"{{name}} will lose access to every property they hold only through “{{group}}”.\",\"action\":\"Remove {{name}}\",\"success\":\"Member removed from the group\",\"error\":\"Failed to remove the member\",\"remove\":\"Remove\"},\"detail\":{\"properties\":\"Properties\",\"members\":\"Members\",\"noProperties\":\"This group has no properties yet.\",\"noMembers\":\"Nobody is assigned to this group yet.\",\"dangerZone\":\"Danger Zone\",\"deleteHint\":\"Deleting the group revokes every access it granted. The properties themselves are untouched.\"},\"edit\":{\"title\":\"Edit Property Group\",\"intro\":\"Rename the group, or change which properties it covers.\",\"submit\":\"Save Changes\",\"success\":\"Property group updated\",\"error\":\"Failed to update the property group\",\"selectProperties\":\"Select properties\",\"noPropertiesHint\":\"This group covers no properties, so it grants nothing.\",\"removeProperty\":\"Remove {{name}}\",\"revokeWarning\":\"You are removing {{properties}} of this group’s properties. Any of its {{members}} members who reach them only through this group will lose access on save.\",\"loading\":\"Loading property group…\"},\"viewGroup\":\"View Group\",\"columnMembers\":\"Members\",\"columnAddress\":\"Address\",\"columnCity\":\"City\",\"columnType\":\"Type\",\"loadError\":\"Couldn't load this property group\"},\"assignUsers\":{\"title\":\"Assign Users\",\"titleMany\":\"Assign Users to {{count}} groups\",\"loadingMembers\":\"Loading members…\",\"assigning\":\"Assigning…\",\"assign\":\"Assign\",\"selectAtLeastOne\":\"Select at least one user\"},\"createGroup\":{\"title\":\"Create Property Group\",\"getStarted\":\"Get Started\",\"creating\":\"Creating…\",\"create\":\"Create Group\",\"goToGroups\":\"Go to Groups\",\"nameRequired\":\"Group name is required\",\"greeting\":{\"title\":\"Create a Property Group\",\"description\":\"Property groups let you organise properties into collections and assign them to team members in bulk.\"},\"details\":{\"title\":\"Group Details\",\"description\":\"Give your group a name and an optional description.\",\"nameLabel\":\"Group Name\",\"namePlaceholder\":\"e.g. Downtown Portfolio\",\"descriptionLabel\":\"Description\",\"descriptionPlaceholder\":\"Optional description...\"},\"properties\":{\"title\":\"Select Properties\",\"description\":\"Choose the properties to include in this group.\",\"selected\":\"{{count}} selected\",\"searchPlaceholder\":\"Search properties...\",\"filters\":\"Filters\",\"done\":\"Done\"},\"success\":{\"title\":\"Group Created!\",\"description\":\"Your property group has been created successfully. You can now assign team members to this group from the groups list.\"}},\"createProperty\":{\"needHelp\":\"Need help?\",\"saveAndExit\":\"Save and exit\",\"loadingDraft\":\"Loading draft...\",\"start\":\"Start\",\"finish\":\"Finish\",\"cancellationSavedFailedTitle\":\"Listing created\",\"cancellationSavedFailedBody\":\"But we couldn't save the cancellation policy — you can set it later.\",\"type\":{\"title\":\"What kind of property are you listing?\"},\"rentalType\":{\"title\":\"What will guests book?\",\"subtitle\":\"Choose the kind of place you're listing — you can add more units later.\",\"fullHouseDescription\":\"Guests have the whole place to themselves.\",\"individualDescription\":\"Guests book individual rooms or suites, like a hotel or B&B.\",\"privateRoomDescription\":\"Guests book a private room in your home.\"},\"rooms\":{\"title\":\"Share some basics about your {{type}}\",\"guestsLabel\":\"Maximum Occupancy (Guests)\",\"guestsHint\":\"How many guests can your place accommodate comfortably?\",\"bedroomsLabel\":\"Bedrooms\",\"bedroomsHint\":\"How many bedrooms can guests use?\",\"bedsLabel\":\"Beds\",\"bedsHint\":\"How many beds are available?\",\"bathroomsLabel\":\"Bathrooms\",\"bathroomsHint\":\"Including half-baths.\"},\"address\":{\"title\":\"Where's your {{type}}?\",\"subtitle\":\"Guests only see the area until they book.\",\"searchCta\":\"Enter your address\",\"searchHint\":\"Search for a street, building or area\",\"useCurrentLocation\":\"Use my current location\",\"useCurrentLocationHint\":\"If you're at the property right now\",\"change\":\"Change\",\"sheetTitle\":\"Enter your address\",\"searchPlaceholder\":\"Search address, building or area\",\"noResultsHint\":\"We couldn't find that. Try a nearby landmark, or enter it manually below.\",\"enterManually\":\"Enter it manually\",\"enterManuallyHint\":\"If your building isn't listed\",\"detailsTitle\":\"Address Details\",\"streetLabel\":\"Street address\",\"streetPlaceholder\":\"Ahmed Heshmat St\",\"buildingLabel\":\"Building\",\"buildingStandaloneLabel\":\"Building name or number\",\"buildingPlaceholder\":\"12\",\"floorLabel\":\"Floor\",\"floorPlaceholder\":\"3\",\"apartmentLabel\":\"Apartment\",\"apartmentPlaceholder\":\"7\",\"cityLabel\":\"City\",\"cityPlaceholder\":\"Cairo\",\"countryLabel\":\"Country\",\"countryPlaceholder\":\"Egypt\",\"directionsLabel\":\"Directions (optional)\",\"directionsPlaceholder\":\"Blue gate, opposite the pharmacy\",\"moreDetails\":\"Add more details\",\"stateLabel\":\"Governorate\",\"statePlaceholder\":\"Cairo\",\"postalCodeLabel\":\"Postal code\",\"postalCodePlaceholder\":\"11511\"},\"location\":{\"title\":\"Where's your {{type}} located?\",\"pinWarning\":\"The pin is a bit far. Does this look right to you?\",\"dragToPlace\":\"Drag the map to set the exact location\",\"mapPreviewOnly\":\"Map preview only — adjust the address on the previous step.\"},\"description\":{\"categoriesTitle\":\"How would you describe your {{type}}?\",\"categoriesSubtitle\":\"Pick 2 highlights that best describe your {{type}}.\",\"phrasesTitle\":\"What makes it {{highlight}}?\",\"phrasesSubtitle\":\"Select 3 key features that highlight this aspect.\"},\"photos\":{\"title\":\"Add photos of your {{type}}\",\"subtitle\":\"We need at least 5 photos to showcase your listing. You can add more later.\",\"uploadPhotos\":\"Upload photos\",\"takePhotos\":\"Take new photos\",\"addMore\":\"Add more photos\",\"coverPhoto\":\"Cover Photo\",\"removeCover\":\"Remove cover photo\",\"removePhoto\":\"Remove photo\",\"minRemaining_one\":\"Add {{count}} more photo to continue\",\"minRemaining_other\":\"Add {{count}} more photos to continue\",\"unsupportedFormat_one\":\"{{names}} is in a format we can’t process. Please use JPEG, PNG or WebP.\",\"unsupportedFormat_other\":\"{{count}} photos are in a format we can’t process ({{names}}). Please use JPEG, PNG or WebP.\",\"tooLarge_one\":\"{{names}} is over {{maxMb}} MB, so we can’t upload it.\",\"tooLarge_other\":\"{{count}} photos are over {{maxMb}} MB, so we can’t upload them ({{names}}).\"},\"spacePhotos\":{\"title\":\"Because every corner counts\",\"subtitle\":\"Add photos to the spaces you want to highlight.\",\"addPhotos\":\"Add photos\",\"addMoreTo\":\"Add more photos to {{space}}\",\"limitReached\":\"Up to {{count}} photos per space\",\"upToLimit\":\"Up to {{count}} photos\"},\"cancellation\":{\"title\":\"Cancellation policy\",\"subtitle\":\"Pick the default policy guests get for free, then optionally offer more flexible policies for a premium on the stay.\",\"defaultPolicy\":\"Default policy\",\"offerMore\":\"Offer more flexible options (optional)\",\"premiumLabel\":\"Premium (% of the stay)\",\"premiumNote\":\"Guests pay the premium upfront when they choose a more flexible policy at checkout.\"},\"ai\":{\"title\":\"Choose your vibe\",\"subtitle\":\"We've gathered insights from your property to generate titles and descriptions that match your vision. Pick one that feels right!\",\"loading\":\"Crafting your property's unique story...\",\"shuffle\":\"Shuffle suggestions\",\"chooseDifferent\":\"Choose a different suggestion\",\"editName\":\"Edit your property name\",\"namePlaceholder\":\"Property name\",\"descriptionPlaceholder\":\"Property description\"},\"submitting\":{\"settingUp\":\"Setting up your property\",\"oops\":\"Oops!\",\"creating\":\"Creating your listing…\",\"uploading\":\"Uploading your photos…\",\"allSet\":\"All set — we’re finishing your photos in the background.\"},\"animations\":{\"entryTitle\":\"Let's get you started!\",\"entrySubtitle\":\"Just pick your space, drop the location, and set your guest count.\",\"amenitiesTitle\":\"Show off your amenities!\",\"amenitiesSubtitle\":\"Highlight the best features of your property to stand out.\",\"photosTitle\":\"Showcase your space\",\"photosSubtitle\":\"Add photos to help guests imagine themselves in your {{type}}.\",\"completionTitle\":\"You're officially a host!\",\"completionSubtitle\":\"Your property is live. Guests can now discover and book your space.\"},\"quickRulesFailedTitle\":\"Some quick rules didn't apply\",\"quickRulesFailedBody\":\"Your property was created, but {{count}} rule(s) couldn't be saved. You can switch them on from the listing at any time.\",\"photosNotUploadedTitle_one\":\"1 photo wasn't uploaded\",\"photosNotUploadedTitle_other\":\"{{count}} photos weren't uploaded\",\"photosNotUploadedBody\":\"Your property was created. Add the missing photos from the listing whenever you're ready.\",\"quickRules\":\"Quick rules\",\"photosSectionNotRecognised\":\"We couldn't work out where these belonged ({{sections}}), so they weren't uploaded. Add them again from the listing.\",\"addMoreUnitsTitle\":\"Property created\",\"addMoreUnitsBody\":\"Add the rest of your units from the property page.\",\"hotel\":{\"continue\":\"Continue\",\"name\":{\"title\":\"What's your {{type}} called?\",\"subtitle\":\"Guests see this name on your property page.\",\"label\":\"Property name\",\"placeholder\":\"e.g. Nile View Hotel\",\"required\":\"Give your property a name\"},\"photos\":{\"title\":\"Add photos of your {{type}}\",\"subtitle\":\"The entrance, the lobby, the pool — the places every guest shares. Add at least 5; each room type gets its own photos later.\"},\"roomTypesAnimation\":{\"title\":\"Now, your room types\",\"subtitle\":\"Describe each kind of room you rent — who it sleeps, how many you have, its photos and its price.\"},\"roomType\":{\"heading\":\"Room type {{number}}\",\"detailsTitle\":\"Describe this room type\",\"nameLabel\":\"Room type name\",\"namePlaceholder\":\"e.g. Deluxe double room\",\"nameRequired\":\"Give the room type a name\",\"nameDuplicate\":\"Two room types can't share a name\",\"kindLabel\":\"What kind of room is it?\",\"guestsLabel\":\"Sleeps\",\"bedroomsLabel\":\"Bedrooms\",\"bedsLabel\":\"Beds\",\"bathroomsLabel\":\"Bathrooms\",\"roomsTitle\":\"How many rooms of this type?\",\"roomsSubtitle\":\"Identical rooms are sold together — guests are given one of them at check-in.\",\"roomsHint\":\"From 1 to 200\",\"roomsInvalid\":\"Enter a whole number from 1 to 200\",\"photosTitle\":\"Add photos of {{name}}\",\"photosSubtitle\":\"Show the room guests will stay in. Add at least one.\",\"rateTitle\":\"Set a price for {{name}}\",\"rateNote\":\"This is the room type's first rate plan, named after the room type. Add more rate plans from the property page.\",\"cancellationTitle\":\"Cancellation policy for {{name}}\",\"nextTitle\":\"Your room types\",\"nextSubtitle\":\"Add another kind of room, or continue to describe your {{type}}.\",\"addAnother\":\"Add another room type\",\"remove\":\"Remove {{name}}\",\"unnamed\":\"Unnamed room type\",\"summarySleeps\":\"Sleeps {{count}}\",\"summaryRooms_one\":\"{{count}} room\",\"summaryRooms_other\":\"{{count}} rooms\",\"amenitiesTitle\":\"What's in {{name}}?\",\"amenitiesSubtitle\":\"Tick what guests find in the room itself. The hotel's shared facilities were covered earlier.\",\"amenitiesRequired\":\"Pick at least one thing guests find in this room type\"},\"ai\":{\"title\":\"Describe your {{type}}\",\"subtitle\":\"We've written descriptions from what you told us about your property and its room types. Pick one and make it yours.\",\"descriptionLabel\":\"Property description\",\"descriptionRequired\":\"Add a description of your property\",\"option\":\"Description {{number}}\"},\"createdTitle\":\"{{name}} is ready\",\"createdBody_one\":\"Your property and its room type were created. Add rate plans and more room types from the property page.\",\"createdBody_other\":\"Your property and its {{count}} room types were created. Add rate plans and more room types from the property page.\"}},\"editListing\":{\"photosNotUploadedBody\":\"Your other changes were saved. Try adding the missing photos again.\",\"editPhotos\":\"Edit photos\",\"editPricing\":\"Edit pricing\",\"editAmenities\":\"Edit amenities\",\"mainPhotos\":\"Main photos\",\"mainPhotosDescription\":\"The Cover photo is what guests see on cards and search. Add, remove, or reorder photos.\",\"spacePhotos\":\"Space photos\",\"spacePhotosDescription\":\"Add photos for each space in your place.\",\"editPhotosHeading\":\"Edit photos\",\"editPhotosDescription\":\"Your Cover photo is what guests see on cards, map pins and search. Add, remove, or reorder photos in each section.\",\"addCategoryPhotos\":\"Add {{label}} photos\",\"addPhotos\":\"Add photos\",\"addToSection\":\"Add to {{label}}\",\"replacePhoto\":\"Replace photo\",\"replaceInSection\":\"Replace the photo in {{label}}\",\"moveToFront\":\"Move to the front\",\"coverPhoto\":\"Cover Photo\",\"removePhoto\":\"Remove photo\",\"editQuickRules\":\"Quick rules\",\"editHouseRules\":\"Edit house rules\",\"saveHouseRules\":\"Save house rules\",\"houseRulesSaveFailed\":\"Couldn't save your house rules. Please try again.\",\"editAutomatedMessages\":\"Automated messages\"},\"details\":{\"live\":\"Live\",\"previewAsGuest\":\"Preview as guest\",\"tabPerformance\":\"Performance\",\"tabDetails\":\"Details\",\"tabCalendarSync\":\"Calendar Sync\",\"feedNotFound\":\"Feed not found\",\"feedNoLongerExists\":\"This feed no longer exists.\",\"upcomingActivity\":\"Upcoming Activity\",\"viewAll\":\"View All\",\"location\":\"{{city}}, {{country}}\",\"quickActions\":\"Quick Actions\",\"editPricing\":\"Edit pricing\",\"editImages\":\"Edit photos\",\"editAmenities\":\"Edit amenities\",\"listingStats\":\"Listing performance\",\"recentChats\":\"Recent Chats\",\"recentChatsEmpty\":\"No conversations for this listing yet.\",\"bookingRequests\":\"Booking Requests\",\"bookingRequestsEmpty\":\"No pending booking requests.\",\"recentReviews\":\"Recent Reviews\",\"editQuickRules\":\"Quick rules\",\"manageRules\":\"Manage rules\",\"actions\":\"Actions\",\"suspended\":\"Suspended\",\"publish\":\"Publish listing\",\"unpublish\":\"Unpublish listing\",\"publishedTitle\":\"Listing published\",\"publishedBody\":\"Guests can find and book it now.\",\"publishedNotLiveTitle\":\"Saved, but not visible yet\",\"publishedNotLivePending\":\"An admin still has to review it before guests can see it.\",\"publishedNotLiveRejected\":\"An admin hasn't approved it, so guests still can't see it.\",\"publishedNotLiveSuspended\":\"This listing is on hold, so guests still can't see it.\",\"unpublishedTitle\":\"Listing unpublished\",\"unpublishedBody\":\"Guests can no longer find or book it.\",\"publicationFailedTitle\":\"Couldn't update this listing\",\"publicationFailedBody\":\"Please try again.\",\"rejectedTitle\":\"Changes needed\",\"rejectedNoNote\":\"An admin didn't approve this listing and left no note. Contact support to find out what to change.\",\"activity\":{\"checkIn\":\"Guest check-in\",\"checkOut\":\"Guest check-out\",\"guestFallback\":\"Guest\",\"empty\":\"No arrivals or departures in the next {{days}} days.\"}},\"preview\":{\"subtitle\":\"Preview as guest\"},\"photoSections\":{\"cover\":\"Cover photo\",\"general\":\"Main photos\",\"living_room\":\"Living room\",\"dining_area\":\"Dining area\",\"kitchen\":\"Kitchen\",\"bedroom\":\"Bedrooms\",\"bathroom\":\"Bathrooms\",\"exterior\":\"Exterior\",\"backyard\":\"Backyard\",\"pool\":\"Pool\",\"patio\":\"Patio\",\"balcony\":\"Balcony\",\"neighbourhood\":\"Neighbourhood\"},\"map\":{\"searchPlaceholder\":\"Find cities, popular destinations, and more!\"}}"),
	blockDates: {
		title: "Block dates",
		roomScope: "Blocking {{room}} only. Other rooms of this type stay open.",
		roomTypeScope_one: "This blocks the room type's {{count}} room. To release a block, open that room.",
		roomTypeScope_other: "This blocks all {{count}} rooms of the type at once. To release a block, open the room itself.",
		instructions: "Tap a day to block it; tap a blocked day to unblock it. Booked dates are unavailable.",
		reasonLabel: "Reason for blocking",
		reasonPlaceholder: "Select a reason",
		detailsRequired: "Details (required)",
		noteOptional: "Note (optional)",
		notePlaceholder: "Add context for this block…",
		noChanges: "No changes yet",
		blockingCount: "Blocking {{count}}",
		unblockingCount: "Unblocking {{count}}",
		blockedCount: "Blocked {{count}}",
		unblockedCount: "Unblocked {{count}}",
		skippedCount: "{{count}} skipped (already booked)",
		updated: "Calendar updated",
		updateError: "Could not update the calendar",
		roomInstructions: "Tap the days to block. Days before today can't be blocked.",
		pickDays: "Pick at least one day",
		noteRequired: "Add details for this reason"
	},
	card: {
		imageAlt: "{{title}} - Image {{number}}",
		addFavorite: "Add to favorites",
		removeFavorite: "Remove from favorites",
		startsFrom: "Starts from",
		perNight: "/ night",
		forNights_one: "for {{count}} night",
		forNights_other: "for {{count}} nights",
		forNightsApprox_one: "approx. for {{count}} night",
		forNightsApprox_other: "approx. for {{count}} nights",
		exclusive: "Exclusive",
		bestPrice: "Best Price",
		instant: "Instant",
		instantBook: "Instant book",
		newArrival: "New",
		bedroomsShort: "{{count}} bd",
		bathroomsShort: "{{count}} ba",
		guestsShort_one: "{{count}} guest",
		guestsShort_other: "{{count}} guests",
		reviewCount: "({{count}})",
		locationType: "{{city}} · {{type}}",
		typeInCity: "{{type}} in {{city}}",
		fromPrice: "from",
		options_one: "{{count}} option",
		options_other: "{{count}} options",
		roomTypes_one: "{{count}} room type",
		roomTypes_other: "{{count}} room types",
		rooms_one: "{{count}} room",
		rooms_other: "{{count}} rooms",
		unitsAndListings: "{{units}} · {{listings}}",
		unitCount_one: "{{count}} unit",
		unitCount_other: "{{count}} units",
		listingCount_one: "{{count}} listing",
		listingCount_other: "{{count}} listings"
	},
	hub: {
		addUnit: "Add unit",
		deleteFailed: "Couldn't delete it. Please try again.",
		empty: {
			title: "No units yet",
			body: "Add the first unit — a room, suite or apartment guests can book — to start taking reservations."
		},
		unit: {
			actions: "Unit actions",
			addListing: "Add listing",
			addRooms: "Add rooms",
			edit: "Edit unit",
			delete: "Delete unit",
			meta: "{{type}} · Sleeps {{guests}} · {{bedrooms}} · {{bathrooms}}",
			bedrooms_one: "{{count}} bedroom",
			bedrooms_other: "{{count}} bedrooms",
			bathrooms_one: "{{count}} bath",
			bathrooms_other: "{{count}} baths",
			noListingsTitle: "No listings on this unit",
			noListingsBody: "A unit can't be booked until it has a listing with a price.",
			deleteTitle: "Delete this unit?",
			deleteBody: "The unit is removed from your property. A unit that has ever carried a booking can't be deleted.",
			deleted: "Unit deleted",
			open: "Open {{unit}}"
		},
		listing: {
			actions: "Listing actions",
			delete: "Delete listing",
			blockRoomType: "Block dates (all rooms)",
			deleteTitle: "Delete this listing?",
			deleteBody: "Guests will no longer be able to find or book it. A listing with upcoming booked or held nights can't be deleted.",
			deleted: "Listing deleted"
		},
		rooms: {
			stepTitle: "Is this one space or several identical ones?",
			single: "One space",
			singleHint: "A single room, apartment or home guests book as it is.",
			several: "Several identical rooms",
			severalHint: "A room type with a number of rooms, sold as one listing. Guests are given a room at check-in.",
			unitCreatedTitle: "The unit was created",
			unitCreatedBody: "Only its rooms are left to add. Adding them again will not create the unit twice.",
			countLabel: "How many rooms?",
			countHint: "From 2 to 200",
			countInvalid: "Enter a whole number from 2 to 200",
			prefixLabel: "Name prefix",
			prefixPlaceholder: "e.g. Room",
			prefixDefault: "Room",
			startLabel: "Start numbering at",
			previewTitle_one: "{{count}} room",
			previewTitle_other: "{{count}} rooms",
			previewHint: "Rename any of them before you save.",
			roomNameAria: "Name of room {{index}}",
			nameRequired: "Give every room a name",
			nameDuplicate: "Two rooms can't share a name",
			submit: "Add room type",
			roomTypeAdded: "Room type added",
			addRoomsTitle: "Add rooms to {{type}}",
			addRoomsSubmit: "Add rooms",
			roomsAdded: "Rooms added",
			unnamed: "Unnamed room",
			summary_one: "{{count}} room",
			summary_other: "{{count}} rooms",
			summaryOutOfOrder: "{{count}} out of order",
			actions: "Actions for {{room}}",
			rename: "Rename",
			markOutOfOrder: "Mark out of order",
			markActive: "Mark active",
			blockDates: "Block dates",
			delete: "Delete room",
			deleteLastReason: "A room type keeps at least one room",
			deleteInUseReason_one: "{{count}} booking is still on this room",
			deleteInUseReason_other: "{{count}} bookings are still on this room",
			deleteTitle: "Delete this room?",
			deleteBody: "A room that has ever carried a stay can't be deleted; mark it out of order instead.",
			deleted: "Room deleted",
			renameTitle: "Rename room",
			renameLabel: "Room name",
			renamed: "Room renamed",
			statusUpdated: "Room updated",
			outOfOrderTitle: "Bookings are still on this room",
			outOfOrderBody_one: "The room is out of order, but {{count}} booking still has a night on it. Open each booking and reassign it to another room.",
			outOfOrderBody_other: "The room is out of order, but {{count}} bookings still have a night on it. Open each booking and reassign it to another room.",
			openCalendar: "Open the calendar",
			countHintFromOne: "From 1 to 200"
		},
		form: {
			addUnitTitle: "Add a unit",
			addUnitSubmit: "Add unit",
			unitAdded: "Unit added",
			editUnitTitle: "Edit unit",
			unitSaved: "Unit saved",
			unitNameLabel: "Unit name",
			unitNamePlaceholder: "e.g. Deluxe double room",
			unitNotFoundTitle: "We couldn't find that unit",
			unitNotFoundBody: "Open it again from the property page.",
			addListingTitle: "Add a listing",
			addListingSubmit: "Add listing",
			listingAdded: "Listing added",
			listingTitleLabel: "Listing title",
			listingDescriptionLabel: "Description",
			saveFailed: "Couldn't save your changes. Please try again.",
			numberInvalid: "Enter a valid number",
			priceInvalid: "Enter a price greater than 0",
			nameTooLong: "Keep the name under 120 characters",
			amenitiesRequired: "Choose at least one amenity"
		},
		property: {
			editName: "Edit name",
			editNameTitle: "Edit property name",
			nameLabel: "Property name",
			namePlaceholder: "e.g. Nile View Hotel",
			nameRequired: "Give your property a name",
			nameTooLong: "Keep the name under 120 characters",
			descriptionLabel: "Description",
			descriptionPlaceholder: "What guests should know about your property",
			nameSaved: "Property name saved",
			editFacilities: "Edit facilities",
			facilitiesSaved: "Facilities saved",
			openCalendar: "Open workspace calendar"
		},
		tabs: {
			label: "Property sections",
			overview: "Overview",
			today: "Today",
			units: "Room types",
			bookings: "Bookings",
			rates: "Rates",
			reports: "Reports",
			photos: "Photos"
		},
		overview: {
			arrivals: "Arrivals today",
			departures: "Departures today",
			inHouse: "In-house tonight",
			occupancy: "Occupancy, last 30 nights",
			openToday: "Open today's board",
			attentionTitle: "Needs attention",
			performanceTitle: "Performance",
			noReportsAccess: "You need the reports permission to see occupancy."
		},
		rates: {
			webHint: "Bulk edit across rate plans is on the web.",
			open: "Open the rates of {{plan}}"
		},
		bookings: {
			allUnits: "All units",
			allRoomTypes: "All room types"
		}
	},
	declinedImage: {
		published: "Published",
		notPublished: "Not published",
		whyDeclined: "Why it was declined",
		flaggedUnderReview: "Flagged — under review",
		flagReviewedKept: "Flag reviewed — kept declined"
	},
	editForms: {
		saveSuccess: "Changes saved",
		saveError: "Failed to save changes",
		saving: "Saving…",
		savingPercent: "Uploading {{percent}}%",
		amenities: { title: "Tell guests what your {{type}} has to offer" },
		features: { title: "Do you have any standout amenities?" },
		safety: { title: "Which safety items does your place have?" },
		essentials: { title: "Finally, let's add room details & essentials" },
		hotelFacilities: {
			title: "What does your hotel offer its guests?",
			subtitle: "The places and services every guest shares — the pool, the restaurant, the front desk. What's inside a room belongs to its room type."
		},
		roomTypeAmenities: {
			title: "What is in this room type?",
			subtitle: "Tick what guests find in the room itself."
		},
		pricing: {
			title: "Pricing",
			subtitle: "Set your listing price and currency.",
			currencyLabel: "Currency",
			basePriceLabel: "Base price per night",
			egpNotice: "All payments are processed in EGP. Prices in other currencies will be converted at the current exchange rate.",
			exclusiveLabel: "Exclusively on Maat",
			exclusiveDescription: "Are you hosting exclusively on Maat? Exclusive properties are better pushed to guests.",
			bestPriceLabel: "Best price on Maat",
			bestPriceDescription: "I'm hosting elsewhere but offering the best price on Maat.",
			instantBookingLabel: "Instant booking",
			instantBookingDescription: "Let guests book instantly without waiting for your approval. Paid bookings are confirmed automatically."
		},
		unitDetails: {
			title: "Unit details",
			subtitle: "How the space is configured and how many guests it sleeps.",
			unitTypeLabel: "Unit type",
			guestsLabel: "Guests",
			bedroomsLabel: "Bedrooms",
			bedsLabel: "Beds",
			bathroomsLabel: "Bathrooms"
		},
		houseRules: {
			title: "Your house, your rules",
			subtitle: "Tick everything that applies to your place. Pets, smoking, parties and photography are also shown to guests when you leave them unticked.",
			checkInLabel: "Check-in after",
			checkOutLabel: "Check-out before"
		}
	},
	favoriteList: {
		savedStays_one: "{{count}} saved stay",
		savedStays_other: "{{count}} saved stays",
		listOptions: "List options",
		rename: "Rename",
		deleteTitle: "Remove this list?",
		deleteDescription: "\"{{name}}\" and its saved listings will be removed. This can't be undone."
	},
	favoritePicker: {
		title: "Save to list",
		createSubtitle: "Create a new favorite list",
		chooseSubtitle: "Choose a list to save this property",
		nameRequired: "Give your list a name",
		listingCount_one: "{{count}} listing",
		listingCount_other: "{{count}} listings",
		listNameLabel: "List name",
		listNamePlaceholder: "e.g. Summer Getaway",
		createAndSave: "Create & Save",
		newList: "New list"
	},
	featuredAreas: {
		title: "Featured destinations",
		subtitle: "Explore our featured destinations",
		explore: "Explore {{name}}"
	},
	feed: {
		title: {
			location: {
				0: "Popular stays in {{name}}",
				1: "Trending stays in {{name}}",
				2: "Featured stays in {{name}}",
				3: "Top-rated stays in {{name}}",
				4: "Amazing stays in {{name}}",
				5: "Top stays in {{name}}"
			},
			amenity: {
				0: "Popular stays with {{name}}",
				1: "Trending stays with {{name}}",
				2: "Featured stays with {{name}}",
				3: "Top-rated stays with {{name}}",
				4: "Amazing stays with {{name}}",
				5: "Top stays with {{name}}"
			},
			propertyType: {
				0: "Popular {{name}} stays",
				1: "Trending {{name}} stays",
				2: "Featured {{name}} stays",
				3: "Top-rated {{name}} stays",
				4: "Amazing {{name}} stays",
				5: "Top {{name}} stays"
			}
		},
		subtitle: {
			location: {
				0: "Discover top-rated stays in {{name}}",
				1: "Find your next getaway in {{name}}",
				2: "Trending properties in {{name}}",
				3: "Handpicked places to stay in {{name}}"
			},
			amenity: {
				0: "Stays featuring {{name}} and more",
				1: "Properties with {{name}} to elevate your stay",
				2: "Top picks with {{name}}",
				3: "Curated listings featuring {{name}}"
			},
			propertyType: {
				0: "Explore the finest {{name}} listings",
				1: "Browse top-rated {{name}} rentals",
				2: "Discover luxury {{name}} options",
				3: "Handpicked {{name}} for your next trip"
			},
			default: "Explore the best stays"
		}
	},
	home: {
		rows: {
			top_rated: "Top rated this weekend",
			hotels: "Hotels",
			guest_favorites: "Guest favorites",
			hidden_gems: "Hidden gems",
			destination: "Available next weekend in {{name}}",
			new_on_maat: "New on Maat",
			recently_viewed: "Recently viewed",
			saved_stays: "Your saved stays this weekend",
			because_you_viewed: "Because you viewed {{title}}",
			back_to_destination: "Back to {{destination}}?"
		},
		seeAll: "See all",
		window: {
			chip_one: "{{dates}} · {{count}} guest",
			chip_other: "{{dates}} · {{count}} guests",
			hint: "Prices are totals for these dates, all fees included. Opens the dates and guests."
		},
		exploreMap: { action: "Explore the map" },
		empty: {
			title: "Nothing open next weekend",
			body: "Every stay is booked for these dates. The map lets you pick your own."
		},
		error: {
			title: "We couldn't load the homepage",
			retry: "Try again"
		},
		intro: {
			title: "Vacation rentals in Egypt – verified chalets, apartments and villas",
			body: "Discover verified stays across the North Coast, El Gouna, Cairo and Egypt’s most-loved destinations. Compare chalets, villas and furnished apartments, explore real photos and guest reviews, then choose your dates for exact pricing with secure payment and flexible installment options. Ancient values. Modern stays."
		}
	},
	quickActions: {
		blockDates: {
			label: "Block Dates",
			description: "Mark unavailable"
		},
		pricing: {
			label: "Pricing",
			description: "Rates & fees"
		},
		photos: {
			label: "Photos",
			description: "Manage media"
		},
		amenities: {
			label: "Amenities",
			description: "Edit amenities"
		},
		calendar: {
			label: "Calendar",
			description: "View calendar"
		},
		quickRules: {
			label: "Quick rules",
			description: "Turn common pricing and booking rules on in one tap"
		},
		houseRules: {
			label: "House rules",
			description: "What guests may and may not do"
		},
		automatedMessages: {
			label: "Automated messages",
			description: "Message guests automatically when a booking reaches a milestone."
		}
	},
	rejectedPhotos: {
		title: "Photos needing attention ({{count}})",
		intro: "These photos weren’t published because they didn’t pass our automated checks. If you think a decline is a mistake, flag it and an admin will review it.",
		flagAsMistake: "Flag as a mistake",
		flaggedTitle: "Flagged for review",
		flaggedDescription: "An admin will take a look shortly.",
		flagError: "Could not flag the photo",
		modalTitle: "Flag this photo for review",
		modalDescription: "Tell us why you think this photo should be published. An admin will review it.",
		reasonRequired: "Tell us why this photo should be published",
		reasonFieldLabel: "Reason",
		reasonPlaceholder: "e.g. This is a genuine photo of the bedroom…",
		submitFlag: "Submit flag"
	},
	renameFavorite: {
		title: "Rename list",
		nameRequired: "List name is required",
		listNameLabel: "List name"
	},
	sections: {
		amenities: {
			title: "Amenities",
			empty: "No amenities listed yet.",
			more: "+{{count}} more"
		},
		photos: {
			title: "Photos",
			empty: "No photos yet.",
			more: "+{{count}} more"
		},
		pricing: {
			title: "Pricing",
			perNight: "/ night",
			baseRate: "base rate",
			pricedByPricelabs: "Priced by PriceLabs",
			pricelabsNote: "PriceLabs sets the nightly rate guests are quoted. This is the base rate it starts from.",
			bestPrice: "Best price",
			exclusive: "Exclusive",
			instantBook: "Instant Book"
		},
		unitDetails: {
			title: "Unit details",
			guests: "Guests",
			bedrooms: "Bedrooms",
			beds: "Beds",
			bathrooms: "Bathrooms",
			address: "Address"
		}
	},
	stats: {
		totalBookings: "Total Bookings",
		totalEarned: "Total Earned",
		avgRating: "Avg Rating",
		occupancyRate: "Occupancy Rate",
		reviewCount_one: "{{count}} review",
		reviewCount_other: "{{count}} reviews"
	},
	favorites: { empty: "You haven't saved any favorites yet." },
	listing: {
		amenities: {
			title: "What this place offers",
			showAll_one: "Show 1 amenity",
			showAll_other: "Show all {{count}} amenities",
			notIncluded: "Not included",
			mayNotHave: "This place may not have a {{item}}",
			inRoomTitle: "In the room"
		},
		facilities: { title: "Hotel facilities" },
		attractions: {
			empty: "No nearby places found for this category.",
			loading: "Loading nearby places…",
			title: "Nearby attractions"
		},
		availability: { title: "Availability" },
		badges: { new: "New" },
		book: {
			instant: "Book instantly",
			request: "Request to book",
			suspendedBody: "This listing is temporarily unavailable for new bookings.",
			suspendedTitle: "Currently unavailable",
			unavailable: "Unavailable",
			checkAvailability: "Check availability"
		},
		cancellation: {
			disclaimer: "Review the host's full cancellation policy, which applies even if you cancel for illness or disruptions.",
			reviewFallback: "Review the host's cancellation policy",
			stageRefund: "{{label}} — {{percent}}% refund",
			title: "Cancellation Policy",
			refundFull: "Full refund",
			refundNone: "No refund",
			refundPartial: "{{percent}}% refund"
		},
		dates: {
			addDate: "Add date",
			addDates: "Add dates",
			checkIn: "Check in",
			checkOut: "Check out",
			select: "Select dates"
		},
		description: {
			autoTranslated: "Automatically translated",
			showOriginal: "Show original",
			title: "About this place",
			translate: "Translate",
			translateFailed: "Translation is unavailable right now. Please try again later.",
			translating: "Translating…"
		},
		gallery: {
			imageAlt: "Property image {{number}}",
			imageAltPrefix: "Property image",
			mainImageAlt: "Property main",
			showAll: "Show all photos",
			counter: "{{index}} / {{total}}",
			openTour: "Open the photo tour",
			openPhoto: "Open photo {{number}} of {{total}}",
			openPhotoIn: "Open photo {{number}} in {{section}}"
		},
		host: {
			addFavorite: "Add to favorites",
			fallbackName: "Host",
			label: "Host",
			message: "Message host",
			removeFavorite: "Remove from favorites",
			share: "Share property",
			viewProfile: "View {{name}}'s profile",
			sectionTitle: "Meet your host",
			hostedBy: "Hosted by {{name}}"
		},
		highlights: { label: "Highlights" },
		houseRules: {
			title: "House Rules",
			checkInAfter: "Check-in after {{time}}",
			checkOutBefore: "Check-out before {{time}}"
		},
		location: {
			exploreNearby: "Explore nearby",
			title: "Where you'll be"
		},
		sleep: {
			title: "Where you'll sleep",
			openRoom: "Open {{room}} photos"
		},
		nav: {
			label: "On this page",
			photos: "Photos",
			overview: "Overview",
			amenities: "Amenities",
			reviews: "Reviews",
			location: "Location",
			host: "Host",
			thingsToKnow: "Things to know"
		},
		price: {
			details: "Price details",
			fromPerNight: "from {{price}} per night",
			perNight: "/ night",
			forNights_one: "for {{count}} night",
			forNights_other: "for {{count}} nights",
			stayTotal: "Total",
			stayTotalApprox: "Approx. total",
			startsFrom: "Starts from",
			totalForNights_one: "{{price}} for {{count}} night",
			totalForNights_other: "{{price}} for {{count}} nights",
			totalNights_one: "for {{count}} night · incl. fees",
			totalNights_other: "for {{count}} nights · incl. fees",
			youllPay: "You'll pay",
			addDatesForPrices: "Add dates for prices"
		},
		requirements: { title: "Booking requirements" },
		safety: {
			title: "Health & Safety",
			devices: "Safety devices",
			notReported: "Not reported by the host"
		},
		share: {
			failed: "Unable to share link",
			fallbackTitle: "Check out this property",
			linkCopied: "Link copied to clipboard",
			action: "Share property",
			message: "Check out {{title}} on Maat Stays"
		},
		summary: {
			bathrooms: "{{count}} Bathrooms",
			bedrooms: "{{count}} Bedrooms",
			guests: "{{count}} Guests",
			typeInCity: "{{type}} in {{city}}, {{country}}",
			reviewsLink_one: "{{count}} review",
			reviewsLink_other: "{{count}} reviews",
			unitInCity: "{{type}} in {{city}}",
			beds_one: "{{count}} Bed",
			beds_other: "{{count}} Beds",
			sharedSpaces: "Your own room in a home, plus access to shared spaces",
			roomCount_one: "{{count}} room",
			roomCount_other: "{{count}} rooms",
			propertyRating_one: "{{average}} · {{count}} review across {{rooms}}",
			propertyRating_other: "{{average}} · {{count}} reviews across {{rooms}}"
		},
		calendar: {
			nightsIn_one: "{{count}} night in {{city}}",
			nightsIn_other: "{{count}} nights in {{city}}",
			nights_one: "{{count}} night",
			nights_other: "{{count}} nights",
			selectDates: "Select check-in date",
			addDatesHint: "Add your travel dates for exact pricing",
			clearDates: "Clear dates",
			save: "Save",
			editDates: "Choose your dates",
			pickCheckout: "Select check-out date"
		},
		rail: {
			guests: "Guests",
			guestCount_one: "{{count}} guest",
			guestCount_other: "{{count}} guests",
			decreaseGuests: "Decrease guests",
			increaseGuests: "Increase guests",
			notCharged: "You won't be charged yet",
			nightlyRow_one: "{{price}} x {{count}} night",
			nightlyRow_other: "{{price}} x {{count}} nights"
		},
		photoTour: {
			title: "Photo tour",
			close: "Close photo tour"
		},
		titleRow: {
			share: "Share",
			save: "Save",
			saved: "Saved"
		},
		thingsToKnow: {
			title: "Things to know",
			houseRules: "House rules",
			safety: "Safety & property",
			cancellation: "Cancellation policy",
			showMore: "Show more",
			notReported: "{{item}} not reported",
			intro: {
				cancellation: "Make sure you're comfortable with this host's policy before you book.",
				houseRules: "You'll be staying in someone's home, so please treat it with care and respect.",
				safety: "Avoid surprises by looking over these important details about the property."
			}
		},
		nearby: { title: "More stays nearby" },
		otherRooms: {
			title: "Other rooms at this property",
			view: "View"
		}
	},
	map: { card: {
		bestPrice: "Best price",
		exclusive: "Exclusive"
	} },
	preview: {
		title: "Listing preview",
		close: "Close preview",
		perNight: "/ night",
		hostedBy: "Hosted by {{name}}",
		viewFullDetails: "View full details",
		stay: {
			totalForNights_one: "Total for {{count}} night",
			totalForNights_other: "Total for {{count}} nights"
		},
		gallery: {
			mainImageAlt: "Property main",
			imageAlt: "Property image {{number}}",
			imageAltPrefix: "Property image"
		},
		facts: {
			guests_one: "{{count}} guest",
			guests_other: "{{count}} guests",
			bedrooms_one: "{{count}} bedroom",
			bedrooms_other: "{{count}} bedrooms",
			beds_one: "{{count}} bed",
			beds_other: "{{count}} beds",
			bathrooms_one: "{{count}} bathroom",
			bathrooms_other: "{{count}} bathrooms"
		},
		location: { title: "Where you'll be" },
		description: { title: "About this place" }
	},
	createProperty: { quickRules: {
		title: "Set your house rules",
		subtitle: "Switch on the ones you want. You can change or add more later, and build fully custom rules any time."
	} },
	quickRules: {
		empty: "No quick rules are available yet. You can still build any rule you like from Pricing or Bookings.",
		feeInListingCurrency: "Charged once per booking, in the listing currency ({{amount}}).",
		groups: {
			pricing: "Pricing",
			booking: "Booking",
			messaging: "Automated messages"
		},
		days: {
			Monday: "Mon",
			Tuesday: "Tue",
			Wednesday: "Wed",
			Thursday: "Thu",
			Friday: "Fri",
			Saturday: "Sat",
			Sunday: "Sun"
		},
		"booking.min_stay": {
			label: "Minimum stay",
			description: "Reject bookings shorter than this.",
			unit: "nights"
		},
		"booking.max_stay": {
			label: "Maximum stay",
			description: "Reject bookings longer than this.",
			unit: "nights"
		},
		"booking.no_checkout_days": {
			label: "No checkout on",
			description: "Days guests can't check out, so you have time to turn the place over."
		},
		"booking.weekend_min_stay": {
			label: "Weekend minimum stay",
			description: "Applies when guests check in on a Friday or Saturday.",
			unit: "nights"
		},
		"pricing.weekend_surcharge": {
			label: "Weekend surcharge",
			description: "Added to Thursday, Friday and Saturday nights. Shown on the calendar.",
			unit: "%"
		},
		"pricing.long_stay_discount": {
			label: "Long-stay discount",
			description: "For stays of 7 nights or more. Applied at checkout, not on the calendar.",
			unit: "%"
		},
		"pricing.large_group_surcharge": {
			label: "Large group surcharge",
			description: "For bookings of 5 guests or more. Applied at checkout.",
			unit: "%"
		},
		"pricing.cleaning_fee": {
			label: "Cleaning fee",
			description: "A one-time fee added to every booking."
		},
		variables: { hint: "Insert a detail that changes per booking:" },
		"chat.booking_confirmed_welcome": {
			description: "Sent as soon as the booking is confirmed. A good place for what happens next.",
			label: "Welcome a guest when they book"
		},
		"chat.checked_in_settle_in": {
			description: "Sent when the guest confirms they have checked in — never on the arrival date alone.",
			label: "Check in on the guest after they arrive"
		},
		"chat.checked_out_thanks": {
			description: "Sent when the guest confirms they have checked out.",
			label: "Thank a guest after they check out"
		},
		"chat.long_stay_welcome": {
			description: "Sent on confirmation, but only when the stay is 7 nights or longer.",
			label: "Send extra details for stays of a week or more"
		}
	},
	listingRules: {
		title: "Rules",
		description: "Pricing and booking rules applied to this listing.",
		sectionEmpty: "No rules assigned yet.",
		assign: "Assign",
		assignTitle: "Assign {{domain}} rules",
		assignDescription: "Pick rules from your workspace to apply to this listing.",
		assigned_one: "{{count}} rule assigned",
		assigned_other: "{{count}} rules assigned",
		selectRules: "Rules",
		searchRules: "Search your rules",
		pickAtLeastOne: "Pick at least one rule",
		nothingLeftToAssign: "Every rule in this workspace is already on this listing.",
		loadingRules: "Loading rules…",
		unassign: "Remove from this listing",
		openRule: "Open rule",
		ruleOff: "Turned off",
		alsoOnListings_one: "Also on {{count}} other listing",
		alsoOnListings_other: "Also on {{count}} other listings",
		noAccess: "You don't have access to pricing or booking rules.",
		error: "Something went wrong. Please try again.",
		unassignConfirm: "Remove this rule from the listing? It stays on your other listings.",
		cancel: "Cancel",
		back: "Back",
		pricelabs: {
			cardTitle: "PriceLabs pricing",
			cardDescription: "Let PriceLabs set this listing's nightly rates and minimum stays from live market demand.",
			switchLabel: "Use PriceLabs pricing",
			switchDescription: "While this is on, your own pricing and booking rules don't apply to this listing.",
			readOnlyOn: "PriceLabs is setting this listing's rates. You need permission to manage pricing to change that.",
			readOnlyOff: "This listing uses your own pricing rules. You need permission to manage pricing to change that.",
			pushing: "We're sending this listing's calendar and booking history to PriceLabs. Rates start arriving once PriceLabs has processed it and you've switched the listing's sync on in your PriceLabs dashboard.",
			lastSynced: "Rates last received {{date}}",
			awaitingFirstPush: "No rates yet — switch this listing's sync on in your PriceLabs dashboard to start.",
			errorTitle: "The last sync with PriceLabs failed",
			errorNoDetail: "PriceLabs didn't tell us why. Trying again usually clears it.",
			retrySync: "Try syncing again",
			enabled_zero: "PriceLabs now prices this listing.",
			enabled_one: "PriceLabs now prices this listing. {{count}} pricing rule was switched off.",
			enabled_other: "PriceLabs now prices this listing. {{count}} pricing rules were switched off.",
			enableError: "We couldn't switch PriceLabs on for this listing. Please try again.",
			enableConflict: "This listing's prices are set by another integration. It has to be released there before PriceLabs can price it.",
			disabled: "This listing is back on your own pricing.",
			disableError: "We couldn't switch PriceLabs off for this listing. Please try again.",
			enableConfirmTitle: "Let PriceLabs price this listing?",
			enableConfirmBody: "Your pricing and booking rules for this listing will be switched off — not deleted — and PriceLabs will set the nightly rate and minimum stay instead. You can switch back at any time, and your rules will be waiting, still off, for you to turn back on.",
			enableConfirmAction: "Use PriceLabs",
			disableConfirmTitle: "Stop using PriceLabs for this listing?",
			disableConfirmBody: "This listing goes back to your base rate. The rules PriceLabs switched off stay off until you turn them back on — we don't restore them automatically, so a rate you'd forgotten about can't surprise you.",
			disableConfirmAction: "Stop using PriceLabs"
		},
		externalPricing: {
			pricingTitle: "Pricing is managed elsewhere",
			pricingBody: "This listing's nightly rates come from an external pricing source, so your own pricing rules aren't applying. Turn that source off for this listing to use them again.",
			bookingTitle: "Min-stay is managed elsewhere",
			bookingBody: "This listing's minimum stay comes from an external pricing source, so your own booking rules aren't applying. Turn that source off for this listing to use them again.",
			managedExternally: "Managed elsewhere",
			managedTooltip: "An external pricing source sets this listing's rates and minimum stay, so your own rules can't be applied to it. Turn that source off for the listing to assign rules again.",
			pickerExcluded_one: "{{count}} listing is priced by an external source and can't take rules. It's been unselected — assign the rest.",
			pickerExcluded_other: "{{count}} listings are priced by an external source and can't take rules. They've been unselected — assign the rest."
		}
	},
	photoProcessing: {
		title_one: "1 photo is still processing",
		title_other: "{{count}} photos are still processing",
		intro_one: "We’re optimising it now — it’ll appear in your gallery in a moment. You can leave this page.",
		intro_other: "We’re optimising them now — they’ll appear in your gallery in a moment. You can leave this page.",
		failedTitle_one: "1 photo couldn’t be uploaded",
		failedTitle_other: "{{count}} photos couldn’t be uploaded",
		failedIntro_one: "We couldn’t process this photo. Try uploading it again.",
		failedIntro_other: "We couldn’t process these photos. Try uploading them again."
	},
	chooseRoom: {
		title: "Choose your room",
		sheetTitle: "Choose a room",
		chooseRoom: "Choose room",
		fromNightly: "from {{price}} / night",
		addDates: "Add dates",
		filters: {
			label: "Filter rooms",
			freeCancellation: "Free cancellation",
			sleeps: "Sleeps {{count}}+"
		},
		card: {
			sleeps_one: "Sleeps {{count}}",
			sleeps_other: "Sleeps {{count}}",
			beds_one: "{{count}} bed",
			beds_other: "{{count}} beds",
			assignedAtCheckIn: "Assigned at check-in",
			seeRoom_one: "See room · {{count}} photo",
			seeRoom_other: "See room · {{count}} photos",
			seeRoomNoPhotos: "See room",
			roomsLeft_one: "{{count}} room left",
			roomsLeft_other: "{{count}} rooms left",
			soldOut: "Sold out",
			from: "from {{price}}",
			showRates: "Show rates for {{room}}",
			hideRates: "Hide rates for {{room}}",
			imageAlt: "{{room}}"
		},
		rate: {
			totalForNights_one: "total for {{count}} night",
			totalForNights_other: "total for {{count}} nights",
			approxTotalForNights_one: "approx. total for {{count}} night",
			approxTotalForNights_other: "approx. total for {{count}} nights",
			soldOut: "Sold out for these dates",
			select: "Select"
		},
		footer: {
			totalForNights_one: "{{total}} for {{count}} night",
			totalForNights_other: "{{total}} for {{count}} nights",
			perNight: "{{price}} / night",
			roomAndRate: "{{room}} · {{rate}}",
			nothingSelected: "Choose a room and a rate to continue",
			reserve: "Reserve"
		},
		empty: {
			title: "No rooms match",
			body: "None of the rooms here fit those filters.",
			clear: "Clear filters",
			noRoomsTitle: "No rooms for this stay",
			noRoomsBody: "Try fewer guests or different dates."
		},
		truncated: "Showing the lowest-priced rates. Change your dates or party to see others.",
		stayFields: "Dates and guests"
	},
	propertyPage: {
		kindLine_one: "{{type}} in {{city}} · {{count}} room type",
		kindLine_other: "{{type}} in {{city}} · {{count}} room types"
	},
	adminContext: {
		title: "Property",
		address: "Address",
		directions: "Directions",
		thisListing: "This listing",
		noListings: "No listings on this unit",
		sortOrderLabel: "Position on the property page",
		sortOrderHint: "Units are listed from the lowest number up.",
		pooledFilterPlaceholder: "Any unit shape",
		pooledOnly: "Room types only",
		notPooled: "Single units only",
		roomsColumn: "Rooms",
		roomTypeLine_one: "{{type}} · {{count}} room",
		roomTypeLine_other: "{{type}} · {{count}} rooms",
		allocatedRoom: "Allocated room: {{room}}"
	},
	inventoryVocab: {
		hotel: {
			unit: "Room type",
			units: "Room types",
			listing: "Rate plan",
			listings: "Rate plans",
			room: "Room",
			rooms: "Rooms",
			unitCount_one: "{{count}} room type",
			unitCount_other: "{{count}} room types",
			listingCount_one: "{{count}} rate plan",
			listingCount_other: "{{count}} rate plans",
			roomCount_one: "{{count}} room",
			roomCount_other: "{{count}} rooms",
			addUnit: "Add room type",
			addListing: "Add rate plan",
			addRooms: "Add rooms",
			editUnit: "Edit room type",
			deleteUnit: "Delete room type",
			deleteListing: "Delete rate plan",
			unitActions: "Room type actions",
			listingActions: "Rate plan actions",
			unitAdded: "Room type added",
			listingAdded: "Rate plan added",
			unitSaved: "Room type saved",
			unitDeleted: "Room type deleted",
			listingDeleted: "Rate plan deleted",
			deleteUnitTitle: "Delete this room type?",
			deleteUnitBody: "The room type is removed from your property. A room type that has ever carried a booking can't be deleted.",
			deleteListingTitle: "Delete this rate plan?",
			deleteListingBody: "Guests will no longer be able to book it. A rate plan with upcoming booked or held nights can't be deleted.",
			noListingsTitle: "No rate plans on this room type",
			noListingsBody: "A room type can't be booked until it has a rate plan with a price.",
			emptyTitle: "No room types yet",
			emptyBody: "Add the first room type — the rooms guests book, with a price — to start taking reservations.",
			tabUnits: "Room types",
			pickListing: "Choose a rate plan",
			addUnitTitle: "Add a room type",
			addUnitSubmit: "Add room type",
			editUnitTitle: "Edit room type",
			addListingTitle: "Add a rate plan",
			addListingSubmit: "Add rate plan",
			unitNameLabel: "Room type name",
			unitNamePlaceholder: "e.g. Deluxe double room",
			listingTitleLabel: "Rate plan name",
			listingTitleRequired: "Give the rate plan a name"
		},
		home: {
			unit: "Unit",
			units: "Units",
			listing: "Listing",
			listings: "Listings",
			room: "Room",
			rooms: "Rooms",
			unitCount_one: "{{count}} unit",
			unitCount_other: "{{count}} units",
			listingCount_one: "{{count}} listing",
			listingCount_other: "{{count}} listings",
			roomCount_one: "{{count}} room",
			roomCount_other: "{{count}} rooms",
			addUnit: "Add unit",
			addListing: "Add listing",
			addRooms: "Add rooms",
			editUnit: "Edit unit",
			deleteUnit: "Delete unit",
			deleteListing: "Delete listing",
			unitActions: "Unit actions",
			listingActions: "Listing actions",
			unitAdded: "Unit added",
			listingAdded: "Listing added",
			unitSaved: "Unit saved",
			unitDeleted: "Unit deleted",
			listingDeleted: "Listing deleted",
			deleteUnitTitle: "Delete this unit?",
			deleteUnitBody: "The unit is removed from your property. A unit that has ever carried a booking can't be deleted.",
			deleteListingTitle: "Delete this listing?",
			deleteListingBody: "Guests will no longer be able to find or book it. A listing with upcoming booked or held nights can't be deleted.",
			noListingsTitle: "No listings on this unit",
			noListingsBody: "A unit can't be booked until it has a listing with a price.",
			emptyTitle: "No units yet",
			emptyBody: "Add the first unit — a room, suite or apartment guests can book — to start taking reservations.",
			tabUnits: "Units",
			pickListing: "Choose a listing",
			addUnitTitle: "Add a unit",
			addUnitSubmit: "Add unit",
			editUnitTitle: "Edit unit",
			addListingTitle: "Add a listing",
			addListingSubmit: "Add listing",
			unitNameLabel: "Unit name",
			unitNamePlaceholder: "e.g. Deluxe double room",
			listingTitleLabel: "Listing title",
			listingTitleRequired: "Give the listing a title"
		}
	}
};
//#endregion
export { e as default };
